import { default as indexOjdMVbtk98Meta } from "/home/node/apps/claimant-portal-ui/pages/actions/[actionId]/index.vue?macro=true";
import { default as successFsnZX8KGMfMeta } from "/home/node/apps/claimant-portal-ui/pages/actions/[actionId]/success.vue?macro=true";
import { default as indexEQsLiAUNrcMeta } from "/home/node/apps/claimant-portal-ui/pages/auth/index.vue?macro=true";
import { default as blankPqjXqwCg9QMeta } from "/home/node/apps/claimant-portal-ui/pages/blank.vue?macro=true";
import { default as completed_45actionsGQqVCKzlfdMeta } from "/home/node/apps/claimant-portal-ui/pages/completed-actions.vue?macro=true";
import { default as demoKQHn1wyBdHMeta } from "/home/node/apps/claimant-portal-ui/pages/demo.vue?macro=true";
import { default as AccessDeniedMi9ag7awtEMeta } from "/home/node/apps/claimant-portal-ui/pages/error/AccessDenied.vue?macro=true";
import { default as ExpiredLinktSLLaTLkzIMeta } from "/home/node/apps/claimant-portal-ui/pages/error/ExpiredLink.vue?macro=true";
import { default as InternalErrorovnqZ1KulGMeta } from "/home/node/apps/claimant-portal-ui/pages/error/InternalError.vue?macro=true";
import { default as NoUserFoundDbpkkhItf2Meta } from "/home/node/apps/claimant-portal-ui/pages/error/NoUserFound.vue?macro=true";
import { default as PageNotFound8xwvCo04XvMeta } from "/home/node/apps/claimant-portal-ui/pages/error/PageNotFound.vue?macro=true";
import { default as WrongAuthProviderQpt1gnf06GMeta } from "/home/node/apps/claimant-portal-ui/pages/error/WrongAuthProvider.vue?macro=true";
import { default as _91errorCode_93euXH1ZQqffMeta } from "/home/node/apps/claimant-portal-ui/pages/error/[errorCode].vue?macro=true";
import { default as indexeSPSJbLzOmMeta } from "/home/node/apps/claimant-portal-ui/pages/files/[actionId]/direct-deposit/index.vue?macro=true";
import { default as _91fileId_932tARDUeUx8Meta } from "/home/node/apps/claimant-portal-ui/pages/files/[actionId]/file/[fileId].vue?macro=true";
import { default as _91actionId_9324MPFlXKdjMeta } from "/home/node/apps/claimant-portal-ui/pages/files/[actionId].vue?macro=true";
import { default as index12VOq0JiWrMeta } from "/home/node/apps/claimant-portal-ui/pages/files/index.vue?macro=true";
import { default as forgot_45passwordLFbnfxI74kMeta } from "/home/node/apps/claimant-portal-ui/pages/forgot-password.vue?macro=true";
import { default as helptq92UC0jNZMeta } from "/home/node/apps/claimant-portal-ui/pages/help.vue?macro=true";
import { default as index46qPLH4OqNMeta } from "/home/node/apps/claimant-portal-ui/pages/index.vue?macro=true";
import { default as _91token_93h0pAixTJGuMeta } from "/home/node/apps/claimant-portal-ui/pages/invite/[token].vue?macro=true";
import { default as _91token_93Gbx0Sc3WKrMeta } from "/home/node/apps/claimant-portal-ui/pages/login/[token].vue?macro=true";
import { default as indexZYVDmUCgZnMeta } from "/home/node/apps/claimant-portal-ui/pages/login/index.vue?macro=true";
import { default as one_45time_45linkuauQ4sgTQ0Meta } from "/home/node/apps/claimant-portal-ui/pages/login/one-time-link.vue?macro=true";
import { default as passwordTNJkgvy1u5Meta } from "/home/node/apps/claimant-portal-ui/pages/login/password.vue?macro=true";
import { default as _91token_93keVpzWwxKLMeta } from "/home/node/apps/claimant-portal-ui/pages/password-reset/[token].vue?macro=true";
import { default as indexWN2hpKX6ufMeta } from "/home/node/apps/claimant-portal-ui/pages/password-reset/index.vue?macro=true";
import { default as profileKZa8PQ9FmrMeta } from "/home/node/apps/claimant-portal-ui/pages/profile.vue?macro=true";
import { default as indexa1pdrTrZWrMeta } from "/home/node/apps/claimant-portal-ui/pages/public/actions/[unauthenticatedToken]/index.vue?macro=true";
import { default as successYDAi1Kec4SMeta } from "/home/node/apps/claimant-portal-ui/pages/public/actions/[unauthenticatedToken]/success.vue?macro=true";
import { default as indexKsxcf7J22tMeta } from "/home/node/apps/claimant-portal-ui/pages/signup/index.vue?macro=true";
export default [
  {
    name: indexOjdMVbtk98Meta?.name ?? "actions-actionId",
    path: indexOjdMVbtk98Meta?.path ?? "/actions/:actionId()",
    meta: indexOjdMVbtk98Meta || {},
    alias: indexOjdMVbtk98Meta?.alias || [],
    redirect: indexOjdMVbtk98Meta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/actions/[actionId]/index.vue").then(m => m.default || m)
  },
  {
    name: successFsnZX8KGMfMeta?.name ?? "actions-actionId-success",
    path: successFsnZX8KGMfMeta?.path ?? "/actions/:actionId()/success",
    meta: successFsnZX8KGMfMeta || {},
    alias: successFsnZX8KGMfMeta?.alias || [],
    redirect: successFsnZX8KGMfMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/actions/[actionId]/success.vue").then(m => m.default || m)
  },
  {
    name: indexEQsLiAUNrcMeta?.name ?? "auth",
    path: indexEQsLiAUNrcMeta?.path ?? "/auth",
    meta: indexEQsLiAUNrcMeta || {},
    alias: indexEQsLiAUNrcMeta?.alias || [],
    redirect: indexEQsLiAUNrcMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/auth/index.vue").then(m => m.default || m)
  },
  {
    name: blankPqjXqwCg9QMeta?.name ?? "blank",
    path: blankPqjXqwCg9QMeta?.path ?? "/blank",
    meta: blankPqjXqwCg9QMeta || {},
    alias: blankPqjXqwCg9QMeta?.alias || [],
    redirect: blankPqjXqwCg9QMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/blank.vue").then(m => m.default || m)
  },
  {
    name: completed_45actionsGQqVCKzlfdMeta?.name ?? "completed-actions",
    path: completed_45actionsGQqVCKzlfdMeta?.path ?? "/completed-actions",
    meta: completed_45actionsGQqVCKzlfdMeta || {},
    alias: completed_45actionsGQqVCKzlfdMeta?.alias || [],
    redirect: completed_45actionsGQqVCKzlfdMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/completed-actions.vue").then(m => m.default || m)
  },
  {
    name: demoKQHn1wyBdHMeta?.name ?? "demo",
    path: demoKQHn1wyBdHMeta?.path ?? "/demo",
    meta: demoKQHn1wyBdHMeta || {},
    alias: demoKQHn1wyBdHMeta?.alias || [],
    redirect: demoKQHn1wyBdHMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/demo.vue").then(m => m.default || m)
  },
  {
    name: AccessDeniedMi9ag7awtEMeta?.name ?? "error-AccessDenied",
    path: AccessDeniedMi9ag7awtEMeta?.path ?? "/error/AccessDenied",
    meta: AccessDeniedMi9ag7awtEMeta || {},
    alias: AccessDeniedMi9ag7awtEMeta?.alias || [],
    redirect: AccessDeniedMi9ag7awtEMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/error/AccessDenied.vue").then(m => m.default || m)
  },
  {
    name: ExpiredLinktSLLaTLkzIMeta?.name ?? "error-ExpiredLink",
    path: ExpiredLinktSLLaTLkzIMeta?.path ?? "/error/ExpiredLink",
    meta: ExpiredLinktSLLaTLkzIMeta || {},
    alias: ExpiredLinktSLLaTLkzIMeta?.alias || [],
    redirect: ExpiredLinktSLLaTLkzIMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/error/ExpiredLink.vue").then(m => m.default || m)
  },
  {
    name: InternalErrorovnqZ1KulGMeta?.name ?? "error-InternalError",
    path: InternalErrorovnqZ1KulGMeta?.path ?? "/error/InternalError",
    meta: InternalErrorovnqZ1KulGMeta || {},
    alias: InternalErrorovnqZ1KulGMeta?.alias || [],
    redirect: InternalErrorovnqZ1KulGMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/error/InternalError.vue").then(m => m.default || m)
  },
  {
    name: NoUserFoundDbpkkhItf2Meta?.name ?? "error-NoUserFound",
    path: NoUserFoundDbpkkhItf2Meta?.path ?? "/error/NoUserFound",
    meta: NoUserFoundDbpkkhItf2Meta || {},
    alias: NoUserFoundDbpkkhItf2Meta?.alias || [],
    redirect: NoUserFoundDbpkkhItf2Meta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/error/NoUserFound.vue").then(m => m.default || m)
  },
  {
    name: PageNotFound8xwvCo04XvMeta?.name ?? "error-PageNotFound",
    path: PageNotFound8xwvCo04XvMeta?.path ?? "/error/PageNotFound",
    meta: PageNotFound8xwvCo04XvMeta || {},
    alias: PageNotFound8xwvCo04XvMeta?.alias || [],
    redirect: PageNotFound8xwvCo04XvMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/error/PageNotFound.vue").then(m => m.default || m)
  },
  {
    name: WrongAuthProviderQpt1gnf06GMeta?.name ?? "error-WrongAuthProvider",
    path: WrongAuthProviderQpt1gnf06GMeta?.path ?? "/error/WrongAuthProvider",
    meta: WrongAuthProviderQpt1gnf06GMeta || {},
    alias: WrongAuthProviderQpt1gnf06GMeta?.alias || [],
    redirect: WrongAuthProviderQpt1gnf06GMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/error/WrongAuthProvider.vue").then(m => m.default || m)
  },
  {
    name: _91errorCode_93euXH1ZQqffMeta?.name ?? "error-errorCode",
    path: _91errorCode_93euXH1ZQqffMeta?.path ?? "/error/:errorCode()",
    meta: _91errorCode_93euXH1ZQqffMeta || {},
    alias: _91errorCode_93euXH1ZQqffMeta?.alias || [],
    redirect: _91errorCode_93euXH1ZQqffMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/error/[errorCode].vue").then(m => m.default || m)
  },
  {
    name: _91actionId_9324MPFlXKdjMeta?.name ?? "files-actionId",
    path: _91actionId_9324MPFlXKdjMeta?.path ?? "/files/:actionId()",
    children: [
  {
    name: indexeSPSJbLzOmMeta?.name ?? "files-actionId-direct-deposit",
    path: indexeSPSJbLzOmMeta?.path ?? "direct-deposit",
    meta: indexeSPSJbLzOmMeta || {},
    alias: indexeSPSJbLzOmMeta?.alias || [],
    redirect: indexeSPSJbLzOmMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/files/[actionId]/direct-deposit/index.vue").then(m => m.default || m)
  },
  {
    name: _91fileId_932tARDUeUx8Meta?.name ?? "files-actionId-file-fileId",
    path: _91fileId_932tARDUeUx8Meta?.path ?? "file/:fileId()",
    meta: _91fileId_932tARDUeUx8Meta || {},
    alias: _91fileId_932tARDUeUx8Meta?.alias || [],
    redirect: _91fileId_932tARDUeUx8Meta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/files/[actionId]/file/[fileId].vue").then(m => m.default || m)
  }
],
    meta: _91actionId_9324MPFlXKdjMeta || {},
    alias: _91actionId_9324MPFlXKdjMeta?.alias || [],
    redirect: _91actionId_9324MPFlXKdjMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/files/[actionId].vue").then(m => m.default || m)
  },
  {
    name: index12VOq0JiWrMeta?.name ?? "files",
    path: index12VOq0JiWrMeta?.path ?? "/files",
    meta: index12VOq0JiWrMeta || {},
    alias: index12VOq0JiWrMeta?.alias || [],
    redirect: index12VOq0JiWrMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/files/index.vue").then(m => m.default || m)
  },
  {
    name: forgot_45passwordLFbnfxI74kMeta?.name ?? "forgot-password",
    path: forgot_45passwordLFbnfxI74kMeta?.path ?? "/forgot-password",
    meta: forgot_45passwordLFbnfxI74kMeta || {},
    alias: forgot_45passwordLFbnfxI74kMeta?.alias || [],
    redirect: forgot_45passwordLFbnfxI74kMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/forgot-password.vue").then(m => m.default || m)
  },
  {
    name: helptq92UC0jNZMeta?.name ?? "help",
    path: helptq92UC0jNZMeta?.path ?? "/help",
    meta: helptq92UC0jNZMeta || {},
    alias: helptq92UC0jNZMeta?.alias || [],
    redirect: helptq92UC0jNZMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/help.vue").then(m => m.default || m)
  },
  {
    name: index46qPLH4OqNMeta?.name ?? "index",
    path: index46qPLH4OqNMeta?.path ?? "/",
    meta: index46qPLH4OqNMeta || {},
    alias: index46qPLH4OqNMeta?.alias || [],
    redirect: index46qPLH4OqNMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91token_93h0pAixTJGuMeta?.name ?? "invite-token",
    path: _91token_93h0pAixTJGuMeta?.path ?? "/invite/:token()",
    meta: _91token_93h0pAixTJGuMeta || {},
    alias: _91token_93h0pAixTJGuMeta?.alias || [],
    redirect: _91token_93h0pAixTJGuMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/invite/[token].vue").then(m => m.default || m)
  },
  {
    name: _91token_93Gbx0Sc3WKrMeta?.name ?? "login-token",
    path: _91token_93Gbx0Sc3WKrMeta?.path ?? "/login/:token()",
    meta: _91token_93Gbx0Sc3WKrMeta || {},
    alias: _91token_93Gbx0Sc3WKrMeta?.alias || [],
    redirect: _91token_93Gbx0Sc3WKrMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/login/[token].vue").then(m => m.default || m)
  },
  {
    name: indexZYVDmUCgZnMeta?.name ?? "login",
    path: indexZYVDmUCgZnMeta?.path ?? "/login",
    meta: indexZYVDmUCgZnMeta || {},
    alias: indexZYVDmUCgZnMeta?.alias || [],
    redirect: indexZYVDmUCgZnMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: one_45time_45linkuauQ4sgTQ0Meta?.name ?? "login-one-time-link",
    path: one_45time_45linkuauQ4sgTQ0Meta?.path ?? "/login/one-time-link",
    meta: one_45time_45linkuauQ4sgTQ0Meta || {},
    alias: one_45time_45linkuauQ4sgTQ0Meta?.alias || [],
    redirect: one_45time_45linkuauQ4sgTQ0Meta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/login/one-time-link.vue").then(m => m.default || m)
  },
  {
    name: passwordTNJkgvy1u5Meta?.name ?? "login-password",
    path: passwordTNJkgvy1u5Meta?.path ?? "/login/password",
    meta: passwordTNJkgvy1u5Meta || {},
    alias: passwordTNJkgvy1u5Meta?.alias || [],
    redirect: passwordTNJkgvy1u5Meta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/login/password.vue").then(m => m.default || m)
  },
  {
    name: _91token_93keVpzWwxKLMeta?.name ?? "password-reset-token",
    path: _91token_93keVpzWwxKLMeta?.path ?? "/password-reset/:token()",
    meta: _91token_93keVpzWwxKLMeta || {},
    alias: _91token_93keVpzWwxKLMeta?.alias || [],
    redirect: _91token_93keVpzWwxKLMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/password-reset/[token].vue").then(m => m.default || m)
  },
  {
    name: indexWN2hpKX6ufMeta?.name ?? "password-reset",
    path: indexWN2hpKX6ufMeta?.path ?? "/password-reset",
    meta: indexWN2hpKX6ufMeta || {},
    alias: indexWN2hpKX6ufMeta?.alias || [],
    redirect: indexWN2hpKX6ufMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/password-reset/index.vue").then(m => m.default || m)
  },
  {
    name: profileKZa8PQ9FmrMeta?.name ?? "profile",
    path: profileKZa8PQ9FmrMeta?.path ?? "/profile",
    meta: profileKZa8PQ9FmrMeta || {},
    alias: profileKZa8PQ9FmrMeta?.alias || [],
    redirect: profileKZa8PQ9FmrMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/profile.vue").then(m => m.default || m)
  },
  {
    name: indexa1pdrTrZWrMeta?.name ?? "public-actions-unauthenticatedToken",
    path: indexa1pdrTrZWrMeta?.path ?? "/public/actions/:unauthenticatedToken()",
    meta: indexa1pdrTrZWrMeta || {},
    alias: indexa1pdrTrZWrMeta?.alias || [],
    redirect: indexa1pdrTrZWrMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/public/actions/[unauthenticatedToken]/index.vue").then(m => m.default || m)
  },
  {
    name: successYDAi1Kec4SMeta?.name ?? "public-actions-unauthenticatedToken-success",
    path: successYDAi1Kec4SMeta?.path ?? "/public/actions/:unauthenticatedToken()/success",
    meta: successYDAi1Kec4SMeta || {},
    alias: successYDAi1Kec4SMeta?.alias || [],
    redirect: successYDAi1Kec4SMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/public/actions/[unauthenticatedToken]/success.vue").then(m => m.default || m)
  },
  {
    name: indexKsxcf7J22tMeta?.name ?? "signup",
    path: indexKsxcf7J22tMeta?.path ?? "/signup",
    meta: indexKsxcf7J22tMeta || {},
    alias: indexKsxcf7J22tMeta?.alias || [],
    redirect: indexKsxcf7J22tMeta?.redirect || undefined,
    component: () => import("/home/node/apps/claimant-portal-ui/pages/signup/index.vue").then(m => m.default || m)
  }
]